import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { Icon } from '../../../../../../../atoms'

export const CalendarPlaceHolder = () => {
  return (
    <div className={s.emptyCalendar}>
      <Icon name='calendar-disabled' size={62} />

      <FormattedMessage
        id='ui.CalendarPlaceHolder.emptyCalendar'
        defaultMessage="Votre calendrier est désactivé car les options{br}Séjours avec nuitée et Séjours à la journée et Soirées d'entreprise{br}sont désactivées"
        values={{
          br: <br />,
        }}
      />
    </div>
  )
}
